<template>
  <!-- 分页 start-->
  <div class="m-page-list el-pagination is-background">
    <button type="button" class="btn-prev" :disabled='pageNo == 1' @click="handleCurrentChange(pageNo - 1)"><i class="el-icon el-icon-arrow-left"></i></button>
    <ul class="el-pager">
      <li v-for="item of pageList" @click="handleCurrentChange(item.No)" :class="item.No === pageNo ? 'number active' : 'number'">{{ item.No }}</li>
    </ul>
    <button type="button" class="btn-next" :disabled='pageNo == pageCount' @click="handleCurrentChange(pageNo + 1)"><i class="el-icon el-icon-arrow-right"></i></button>
    <!-- <span class="el-pagination__total">共 {{ pageTotal }} 条</span> -->
  </div>
  <!-- 分页 end-->
</template>
<script>
export default {
    props:{
      pageNo: {
        type: Number,
        default: 1,
      },
      pageSize: {
        type: Number,
        default: 10,
      },
      pageTotal: {
        type: Number,
        default: 0,
      },
    },
    data: function () {
      return {
        pageCount: 0,
        pageList: [],
      };
    },
    watch: {
      pageTotal(val) {
        this.pageCount = Math.ceil(this.pageTotal / this.pageSize);
        this.loadPage();
      },
      pageNo(val) {
        this.loadPage();
      }
    },
    methods:{
      handleCurrentChange(val){
        this.$emit('currentChange',val)
      },
      loadPage: function(){
        this.pageList = [];
        var beg = 1;
        var end = this.pageCount == 0 ? 1 : this.pageCount;
        if (this.pageCount > 9) {
          var beg = this.pageNo - 4;
          var end = this.pageNo + 4;
          if (this.pageNo <= 5) {
            beg = 1;
            end = 9;
          } else if (this.pageNo >= this.pageCount - 4) {
            beg = this.pageCount - 8;
            end = this.pageCount;
          }
        }
        for(var i = beg; i <= end; i++){
          this.pageList.push({No:i});
        }
      },
    }
}
</script>


// WEBPACK FOOTER //
// src/common/plugin/pagination.vue